import { Reel } from "@quest/murka-games-behavior-leopard/dist";
import { SlotEventConstants } from "@quest/slot-core/dist/SlotConstants/SlotEventDispatchers";
import { AnimationSymbol, LayeredAnimationSymbol, ReelPanelModel, SpineSymbol, StaticSymbol, SymAnimReel, SymbolConstants, SymbolFactory } from "@quest/slot-core";
import { Container } from "@quest/pixi-bridge";
import { delayedCall ,ingenuity} from "@quest/base-core";
import { GameParserModel } from "../Platform/GameParserModel";
import { gameConstants } from "../Constants/gameConstants";

export class ReelGame extends Reel {
  private stackOffset: number[][][];

  constructor(reelId: number, rows: number, model: ReelPanelModel, pool?: SymbolFactory) {
    super(reelId, rows, model, pool);
  }
  /**
   * to add correct animation name and hide stack
   */
  public playAnimByPos(pos: number, symReel?: Container, opts?: SymAnimReel): void {
    const parent: any = this.parent;
    const sym = parent.getSymbolByPos(this.reelId, pos);
    sym.getStatic().visible = false;
    const icon: SpineSymbol = sym.getAnimation() as SpineSymbol;
    this.stackOffset = (ingenuity.parserModel as GameParserModel).getCommonOffsetsOfStackAndWin();
    if (!icon) {
      return;
    }
    if (!icon.hasEvent(SlotEventConstants.SYMBOL_ANIM_STARTED)) {
      icon.on(SlotEventConstants.SYMBOL_ANIM_STARTED, this.onSymbolAnimationEvent, this);
    }
    if (!icon.hasEvent(SlotEventConstants.SYMBOL_ANIM_ENDED)) {
      icon.on(SlotEventConstants.SYMBOL_ANIM_ENDED, this.onSymbolAnimationEvent, this);
    }
    const symPosition: number[] = [this.reelId, pos];
    const offsetFind: boolean = this.findStackAnimSym(this.stackOffset, symPosition);
    !offsetFind && symReel.addChild(icon);
    symReel.x = symReel.x + 1;
    symReel.x = symReel.x - 1;
    icon.visible = !sym.forceHide;
    this.hiddenIcons.push(icon);
    if (!this.checkSymbolInArray(icon)) {
      this.AllIcons.push(icon);
    }
    this.hideStackStatic();
    const staticAnim = icon.json.animations ? icon.json.animations.static : "static"
    const winAnim = icon.json.animations ? icon.json.animations.anim : "animation"
    icon.playAnim(staticAnim, false, 0);
    setTimeout(() => {
      icon.playAnim(winAnim);
    }, 10);
  }

  /**
   * to hide static behind stack symbol
   */
  private hideStackStatic(): void {
    this.stackOffset.forEach((data: any) => {
      data.forEach((element: any) => {
        const parent: any = this.parent;
        const offset = parent.getSymbolByPos(element[0], element[1]);
        const staticSym = offset.getStatic();
        staticSym.visible = false;
      });
    });
  }
  /**
   * to check if symbol present
   */
  protected checkSymbolInArray(icon: any) {
    let isSymbolAvailable = false;
    for (const element of this.AllIcons) {
      if (element.gridPosition === icon.gridPosition) {
        isSymbolAvailable = true;
      }
    }
    return isSymbolAvailable;
  }
  /**
   * to find stack animation present or not
   */
  private findStackAnimSym(symGrid: number[][][], stackOffset: number[]): boolean {
    for (let reelOffsets of symGrid) {
      for (let i: number = 0; i < reelOffsets.length; i++) {
        if (reelOffsets.length > 1) {
          if (reelOffsets[i][0] === stackOffset[0] && reelOffsets[i][1] === stackOffset[1]) {
            return true;
          }
        }
      }
    }
    return false; // Element is not present
  }
  /**
   * to handle loop animaitons in triggering
   */
  public playTriggerAnimByID(id: number, pos: number, symReel?: Container, opts?: any) {
    let parent: any = this.parent;
    const sym = parent.getSymbolByPos(this.reelId, pos);
    sym.getStatic().visible = false;
    const icon = sym.getAnimation();
    if (!icon.hasEvent(SlotEventConstants.SYMBOL_ANIM_STARTED)) {
      icon.on(SlotEventConstants.SYMBOL_ANIM_STARTED, this.onSymbolAnimationEvent, this);
    }
    if (!icon.hasEvent(SlotEventConstants.SYMBOL_ANIM_ENDED)) {
      icon.on(SlotEventConstants.SYMBOL_ANIM_ENDED, this.onSymbolAnimationEvent, this);
    }
    this.scatterIcons.push(icon);
    symReel && symReel.addChild(icon);
    icon.onComplete.dispose();
    icon.visible = !sym.forceHide;
    icon.playAnim("static", false, 0);
    setTimeout(() => {
      icon.playAnim(opts || "triggering", false);
    }, 10);
    return sym;
  }


  /** update on spin to add symbol fade*/
  public updateSpin(deltaTime: number) {
    if (!this.spinNow) {
      return;
    }
    let id: number;
    let icon;
    let sym;
    if (this.initScroll >= this.model.getSymbolHeight()) {
      this.intLoopCounter++;
      this.initScroll = 0;
      let removeSymbolFromList: boolean = false;
      this.symCollection.forEach((symbol, index) => {
        if (typeof symbol !== "undefined") {
          icon = symbol.getStatic();
          if (this.spinDirection === 1) {
            symbol.setYPosition(symbol.y + this.model.getSymbolHeight() + (this.model.getSymbolSpacingY() || 0));
            symbol.gridPosition++;
          }
          else {
            symbol.setYPosition(symbol.y - (this.model.getSymbolHeight() + (this.model.getSymbolSpacingY() || 0)));
            symbol.gridPosition--;
          }
          icon.visible = true;
          symbol.forceHide = false;
          if (symbol.json.spinStartSym) {
            let spinIcon = symbol.getSpinStartSymAnimation();
            if (!((symbol.gridPosition > this.rows && this.spinDirection === 1) || (symbol.gridPosition < -1 && this.spinDirection === 0))) {
              spinIcon.visible = true;
              this.addChildAt(spinIcon, symbol.gridPosition);
              if (spinIcon instanceof StaticSymbol || spinIcon instanceof SpineSymbol) {
                spinIcon.playAnim(SymbolConstants.DEFAULT_ANIMATION_KEY);
              }
              else if (spinIcon instanceof AnimationSymbol) {
                spinIcon.playAnim(SymbolConstants.DEFAULT_ANIMATION_KEY, undefined, () => {
                  spinIcon.visible = false;
                  this.removeChild(spinIcon);
                });
              }
              else if (spinIcon instanceof LayeredAnimationSymbol) {
                spinIcon.playAnim();
              }
            }
          }
          if ((symbol.gridPosition > this.rows && this.spinDirection === 1) || (symbol.gridPosition < -1 && this.spinDirection === 0)) {
            if (symbol.json.spinSym) {
              const spinIcon = symbol.getSpinAnimation();
              spinIcon.stopAnim();
            }
            symbol.returnToPool();
            this.symCollection[index] = undefined;
            removeSymbolFromList = true;
            icon.off(SlotEventConstants.SYMBOL_ANIM_STARTED);
            icon.off(SlotEventConstants.SYMBOL_ANIM_ENDED);
          }
        }
      });
      if (removeSymbolFromList) {
        const len = this.symCollection.length;
        for (let i: number = len - 1; i >= 0; i--) {
          if (typeof this.symCollection[i] === "undefined") {
            this.symCollection.splice(i, 1);
          }
        }
      }
      if (Array.isArray(this.stops) && this.stops.length > 0 && this.intLoopCounter >= this.intMaxLoops) {
        if (this.spinDirection === 1) {
          const id: number = this.stops[this.stopIndex - 1] as number;
          sym = this.iconsPool.getSymbol(id);
          this.symCollection.unshift(sym);
          sym.gridPosition = -1;
          this.stopIndex--;
        }
        else {
          const id: number = this.stops[this.stopIndex] as number;
          sym = this.iconsPool.getSymbol(id);
          this.symCollection.push(sym);
          sym.gridPosition = this.rows;
          this.stopIndex++;
        }
        icon = sym.getStatic();
        icon.visible = true;
        if (ingenuity.configData.decreaseSpinSpeed) {
          if (this.model.json.decSpinSpeed) {
            this.initSpinSpeed =
              this.initSpinSpeed > this.model.json.minSpeed ? this.initSpinSpeed - this.model.json.decSpinSpeed : this.model.json.minSpeed;
          }
          else {
            this.initSpinSpeed--;
          }
          this.quickSpinSpeed--;
        }
        if (!icon.hasEvent(SlotEventConstants.SYMBOL_ANIM_STARTED)) {
          icon.on(SlotEventConstants.SYMBOL_ANIM_STARTED, this.onSymbolAnimationEvent, this);
        }
        if (!icon.hasEvent(SlotEventConstants.SYMBOL_ANIM_ENDED)) {
          icon.on(SlotEventConstants.SYMBOL_ANIM_ENDED, this.onSymbolAnimationEvent, this);
        }
      }
      else {
        if (this.spinDirection === 1) {
          id = this.model.getCurrentReelset()[this.reelId][this.index];
          sym = this.iconsPool.getSymbol(id);
          this.symCollection.unshift(sym);
          sym.gridPosition = -1;
        }
        else {
          id = this.model.getCurrentReelset()[this.reelId][this.upindex];
          sym = this.iconsPool.getSymbol(id);
          this.symCollection.push(sym);
          sym.gridPosition = this.rows;
        }
        if (sym.json.spinSym) {
          icon = sym.getSpinAnimation();
          this.playSymbolSpinAnimation(icon);
        }
        else if (this.blurSpin) {
          icon = sym.getBlur();
          this.fadeSpinningSymbolOnAnticipation(icon)
        }
        else {
          icon = sym.getStatic();
        }
        icon.visible = true;
      }
      // DJ :: Position where symbol needs to be added in reel.
      let yPos: number = 0;
      if (this.spinDirection === 1) {
        yPos = -this.model.getSymbolHeight() - (this.model.getSymbolSpacingY() || 0);
      }
      else {
        yPos = this.model.getSymbolHeight() * this.rows + (this.model.getSymbolSpacingY() || 0);
      }
      sym.setYPosition(yPos);
      (sym.parent as any) = this;
      this.addChildAt(icon, 0);
      if ((this.spinDirection === 1 && this.stopIndex === 0) || (this.spinDirection === 0 && this.stopIndex === this.rows + 2)) {
        this.stopSpinNow = true;
      }
    }
    this.y =
      this.spinDirection === 1
        ? this.model.reelJson[this.reelId].y + this.initScroll
        : -(this.model.reelJson[this.reelId].y + this.initScroll);
    let delta: number = deltaTime / this.desiredFPSTime, speed, qSpeed;
    if (delta > 1) {
      qSpeed = this.quickSpinSpeed * delta;
      speed = this.initSpinSpeed * delta;
    }
    else {
      qSpeed = this.quickSpinSpeed;
      speed = this.initSpinSpeed;
    }
    if (this.model.quickSpin) {
      this.initScroll += qSpeed + this.anticipationSpeed;
    }
    else {
      this.initScroll += speed + this.anticipationSpeed;
    }
    if (ingenuity.configData.hasOverlaySymbols) {
      this.sortIconsOnType();
    }
    if (this.stopSpinNow) {
      this.spinNow = false;
      this.handleReelStop();
      if (!this.model.noStopBounce) {
        const stopBounceAmt = Array.isArray(this.model.stopBounceAmt) ? this.model.stopBounceAmt[this.reelId] : this.model.stopBounceAmt;
        const stopBounceTime = Array.isArray(this.model.stopBounceTime)
          ? this.model.stopBounceTime[this.reelId]
          : this.model.stopBounceTime;
        const stopBounceTimeout = Array.isArray(this.model.stopBounceTimeout)
          ? this.model.stopBounceTimeout[this.reelId]
          : this.model.stopBounceTimeout;
        const bounce = this.game.add.tween(this);
        bounce.to({
          y: this.spinDirection === 1 ? this.y + stopBounceAmt : this.y - stopBounceAmt,
        }, stopBounceTime, ingenuity.configData.reelStopBounceInEase, false);
        bounce.to({
          y: this.spinDirection === 1 ? this.model.reelJson[this.reelId].y : -this.model.reelJson[this.reelId].y,
        }, stopBounceTimeout, ingenuity.configData.reelStopBounceOutEase, false);
        bounce.onComplete.add(this.spinDone, this);
        bounce.start();
      }
      else {
        delayedCall("stopReel", 10, this.spinDone, this);
      }
    }
  }

  /**
   * function will fade the spinning symbols except sactter symbol
   * only those symbols will fade which are spinning next to the reel with anticipation
   */
  private fadeSpinningSymbolOnAnticipation(symbol: StaticSymbol): void {
    if (ingenuity.configData.currentAnticipation !== -1 && this.reelId > ingenuity.configData.currentAnticipation) {
      symbol.tint = gameConstants.FADED_SYMBOL;
    } else {
      symbol.tint = gameConstants.UNFADED_SYMBOL;
    }
  }
}
